import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import OfficeSettingsModal from '../Settings/OfficeSettingsModal';
import {
  AssetsArt,
  PropertiesArt,
  ContractsArt,
  OffersArt,
  RequestsArt,
  OfficeDocsArt,
} from './ModuleArt';

/**
 * The landing grid shown right after login.
 *
 * `to: null` renders the tile dimmed with a "coming soon" badge — those
 * modules have no page yet. To wire one up later, just fill in its `to`.
 */
const MODULES = [
  { key: 'assets', Art: AssetsArt, to: null },
  { key: 'properties', Art: PropertiesArt, to: '/property' },
  { key: 'contracts', Art: ContractsArt, to: '/contract' },
  { key: 'offers', Art: OffersArt, to: null },
  { key: 'requests', Art: RequestsArt, to: null },
  { key: 'officeDocuments', Art: OfficeDocsArt, to: null },
];

const HomeGrid = () => {
  const { t } = useTranslation();
  const { isSuperAdmin, isOrgAdmin } = useAuth();
  const [showOfficeSettings, setShowOfficeSettings] = useState(false);

  return (
    <div className="ad-page">
      <div className="ad-page-head">
        <div>
          <h1 className="ad-page-title">{t('home.title')}</h1>
          <p className="ad-page-subtitle">{t('home.subtitle')}</p>
        </div>
        <div className="ad-toolbar-group">
          <Link to="/tree" className="ad-btn">
            <i className="fas fa-sitemap"></i>
            {t('tree.title')}
          </Link>
          {(isSuperAdmin || isOrgAdmin) && (
            <button type="button" className="ad-btn" onClick={() => setShowOfficeSettings(true)}>
              <i className="fas fa-sliders"></i>
              {t('settings.title')}
            </button>
          )}
          <Link to="/dashboard" className="ad-btn">
            <i className="fas fa-chart-line"></i>
            {t('home.openDashboard')}
          </Link>
        </div>
      </div>

      <div className="ad-launcher">
        {MODULES.map(({ key, Art, to }) => {
          const label = t(`home.modules.${key}`);
          const art = (
            <>
              <span className="ad-tile-art">
                <Art width="72" height="72" />
              </span>
              <span className="ad-tile-label">{label}</span>
            </>
          );

          if (!to) {
            return (
              <div key={key} className="ad-tile ad-tile-disabled" aria-disabled="true">
                <span className="ad-tile-badge">{t('home.comingSoon')}</span>
                {art}
              </div>
            );
          }

          return (
            <Link key={key} to={to} className="ad-tile">
              {art}
            </Link>
          );
        })}
      </div>

      <OfficeSettingsModal
        show={showOfficeSettings}
        onClose={() => setShowOfficeSettings(false)}
      />
    </div>
  );
};

export default HomeGrid;
